import axios from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { __API_URL__ } from "../SERVER_URL";
import { toast } from "react-toastify";
import { showApiErrorToast } from "../utils/helpers";

const updatePhotoSessionSurveys = async ({ sessionId, stepId, surveyIds }) => {
  const token = localStorage.getItem("token");

  const params = new URLSearchParams();
  if (stepId) params.append("step_id", stepId);

  const res = await axios.put(
    `${__API_URL__}/api/photos/photo-sessions/${sessionId}/surveys/?${params.toString()}`,
    { survey_ids: surveyIds },
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    }
  );

  return res.data;
};

const useUpdatePhotoSessionSurveysMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePhotoSessionSurveys,
    onSuccess: (_, variables) => {
      toast.success("Session surveys updated");
      queryClient.invalidateQueries({
        queryKey: ["photo_session_surveys", variables.sessionId],
      });
    },
    onError: (error) => {
      showApiErrorToast(error, "Failed to update session surveys");
    },
  });
};

export default useUpdatePhotoSessionSurveysMutation;
